import React, { useState, useRef, useEffect } from "react";
import { IoLogoWhatsapp } from "react-icons/io";

const SharePopup = ({ url }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [copied, setCopied] = useState(false);
  const popupRef = useRef(null);

  // ✅ Message customization
  const message = `Hey, check out this report:\n${url}`;
  const whatsappLink = `https://wa.me/?text=${encodeURIComponent(message)}`;

const subject = "Personality Assessment Report Available!";
const emailBody = `Hi there,

Click on the link below to view personality assessment report:
${url}

Regards,
SelfSync Team`;

const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;



  const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(emailBody)}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);

    setTimeout(() => {
      setShowPopup(false);
    }, 2000);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };

    if (showPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPopup]);

  return (
    <div className="relative inline-block" ref={popupRef}>
      <button
        onClick={() => setShowPopup(!showPopup)}
        className="bg-white border border-violet-500 text-violet-600 px-4 py-2 rounded-full shadow-sm hover:bg-violet-50 transition-all font-medium flex items-center gap-2"
      >
        🔗 Share Via
      </button>

      {showPopup && (
        <div className="absolute right-0 mt-3 w-60 bg-white border border-gray-200 rounded-xl shadow-lg p-4 z-50 animate-fade-in">
          <button
            onClick={() => window.open(whatsappLink, "_blank")}
            className="flex items-center w-full gap-3 text-green-600 hover:bg-green-50 p-2 rounded-lg transition"
          >
            <IoLogoWhatsapp className="text-xl" />
            <span className="font-medium">Share on WhatsApp</span>
          </button>

          {/* <button
                        onClick={() => (window.location.href = mailtoLink)}
                        className="flex items-center w-full gap-3 text-blue-600 hover:bg-blue-50 p-2 rounded-lg transition"
                    >
                        <span>✉️</span>
                        <span className="font-medium">Send via Email</span>
                    </button> */}
          <button
            onClick={() => (window.location.href = mailtoLink)}
            className="flex items-center w-full gap-3 text-blue-600 hover:bg-blue-50 p-2 rounded-lg transition"
          >
            ✉️ Send via Email App
          </button>

          <button
            onClick={() => window.open(gmailLink, "_blank")}
            className="flex items-center w-full gap-3 text-gray-700 hover:bg-blue-50 p-2 rounded-lg transition"
          >
            📧 Send via Gmail
          </button>

          <button
            onClick={handleCopy}
            className="flex items-center w-full gap-3 text-gray-700 hover:bg-gray-100 p-2 rounded-lg transition"
          >
            <span>📋</span>
            <span className="font-medium">Copy Link</span>
          </button>

          {copied && (
            <div className="mt-3 text-center text-sm text-green-600 bg-green-50 py-1 rounded">
              ✅ Link copied!
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SharePopup;
